import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import { searchByEndpoint } from '../../actions/search';
import ActionTypeaheadPicker from './ActionTypeaheadPicker';

const DimensionListTypeaheadPicker = ({
  listType,
  searchType,
  searchParamName,
  selectedValue = {},
  onChange = () => {},
  transformResult = r => ({ ...r, header: 'Dimension Lists' }),
  transformItems = r => ({ ...r, header: 'Items' }),
  initialOptions = [],
  ...others
}) => {
  let transformedResult = [];
  const onTypeAction = async (value, dispatch) => {
    const dimensionItemsResult = await dispatch(
      searchByEndpoint(searchType, { isDimensionSearch: true, [searchParamName]: value }),
    );
    const dimensionListResults = await dispatch(
      searchByEndpoint('dimensionLists', { listName: value, listType }),
    );

    let error;
    if (dimensionItemsResult.error) {
      error = dimensionListResults;
    }
    if (dimensionListResults.error) {
      error += `\n${dimensionListResults.error}`;
    }

    // error state does not mean that we shouldn't provide what results we do receive
    const dLitems = dimensionItemsResult.error ? [] : dimensionItemsResult.payload;
    const dLlists = dimensionListResults.error ? [] : dimensionListResults.payload;

    const response = {
      items: []
        .concat(sortBy(dLitems?.map(transformItems), p => p.text))
        .concat(sortBy(dLlists?.map(transformResult), r => r.text)),
      error,
    };
    transformedResult = response.items;
    return transformedResult;
  };
  const headerOrder = ['Items', 'Lists'];
  const initOptions = [...initialOptions, ...transformedResult];
  return ActionTypeaheadPicker({
    selectedValue,
    initOptions,
    onTypeAction,
    onChange,
    headerOrder,
    ...others,
  });
};

DimensionListTypeaheadPicker.propTypes = {
  selectedValue: PropTypes.object,
  listType: PropTypes.string.isRequired,
  searchParamName: PropTypes.string,
  onChange: PropTypes.func,
  transformResult: PropTypes.func,
  transformItems: PropTypes.func,
  initialOptions: PropTypes.array,
};

DimensionListTypeaheadPicker.defaultProps = {
  selectedValue: null,
  initialOptions: [],
  searchParamName: '',
  onChange: () => {},
  transformResult: result => ({
    icon: 'BulletedList',
    key: result.listId,
    id: result.listId,
    text: result.listName,
    dimensionList: result,
    propertyType: 'dimensionList',
    header: 'Lists',
  }),
  transformItems: result => ({
    icon: 'Product',
    key: result.id,
    id: result.id,
    text: result.name,
    value: result,
    propertyType: 'value',
    header: 'Items',
  }),
};

export default DimensionListTypeaheadPicker;
